import { gql } from '@apollo/client';

export const FileUploadFragment = gql`
  fragment FileUpload on FileUpload {
    id
    createdAt
    fileName
    signedUrl
    isValid
    period {
      startMonthYear {
        month
        year
      }
      endMonthYear {
        month
        year
      }
    }
    payrollMonthExpenseSyncEventId
    payrollProviderSyncEventId
  }
`;
